// ResumeStaff.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../../api/axios";

export default function ResumeStaff() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [stoppage, setStoppage] = useState(null);
  const [form, setForm] = useState({ actual_resumption_date: "", remarks: "" });
  const [file, setFile] = useState(null);

  useEffect(() => {
    axios
      .get(`/temporary-stoppages/${id}`)
      .then((res) => setStoppage(res.data))
      .catch((err) => console.error(err));
  }, [id]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(form).forEach(([k, v]) => formData.append(k, v));
    if (file) formData.append("resumption_authority_document", file);

    try {
      await axios.post(`/temporary-stoppages/${id}/resume`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      navigate("/temporary-stoppages");
    } catch (err) {
      console.error(err.response?.data || err);
    }
  };

  if (!stoppage) return <p>Loading...</p>;

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Resume Staff</h2>

      <div className="mb-6 border p-4 rounded bg-gray-50">
        <p>
          <strong>PF No:</strong> {stoppage.pfno}
        </p>
        <p>
          <strong>Reason:</strong> {stoppage.reason}
        </p>
        <p>
          <strong>Status:</strong> {stoppage.status}
        </p>
        <p>
          <strong>Start:</strong> {stoppage.start_date}
        </p>
        <p>
          <strong>Expected Resumption:</strong> {stoppage.expected_resumption_date}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
        <input
          type="date"
          name="actual_resumption_date"
          value={form.actual_resumption_date}
          onChange={handleChange}
          className="border p-2 w-full rounded"
          required
        />
        <textarea
          name="remarks"
          value={form.remarks}
          onChange={handleChange}
          placeholder="Remarks"
          className="border p-2 w-full rounded"
        />
        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
          className="border p-2 w-full rounded"
        />
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-lg">
          Submit
        </button>
      </form>
    </div>
  );
}
